











import PressKitCard from '~/components/globals/cards/press-kit/card'

export default

	components: { PressKitCard }

	props: block: Object

	computed:
		assets: -> @block.assets || []

